import { useCallback, useEffect, useState } from "react";
import ImpoundsService from "../../../../../../../../../services/accounts/impounds";
import { transformToFormatted } from "../../../../../../../../../lib/transformToFloat";

export const useFetchImpoundAccount = (id: string | null) => {
  const [isLoading, setIsLoading] = useState<boolean>(id !== null);

  const [impoundAccount, setImpoundAccount] = useState<any | null>(() => (id === null ? { balance: "0.00" } : null));

  const fetchData = useCallback(async () => {
    if (id !== null) {
      try {
        const res = await ImpoundsService.fetch(id);
        const values = {
          ...res,
          impoundAccount: res.impoundAccount.toString(),
          impoundTypeId: res.impoundTypeId,
          amount: transformToFormatted(res.amount),
          balance: res.balance || "0.00"
        };
        setImpoundAccount(values);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, impoundAccount };
};
